import type { JSX } from 'react';

import type { ErrorHandlerProps } from 'src/app/pages/search/pageContext';

export function SearchErrorHandler({ context: { error } }: ErrorHandlerProps): JSX.Element {
	throw new Error(`Failed to retrieve data for Search page (error: ${error})`);
}
